<template>
  <div>
  
    <div class="cpp-content">
      
      <div class="panel">
        
        <div class="notes">
          
          <div>
              <div v-for="(c,index) in exercises" v-if="tab == 'exercise'" :key="'ex-'+index">
                <div @click.stop="openClass(c)"  class="class-row">
                  <div class="class-icon">
                    <i class="fas fa-folder"></i>
                  </div>
                  <span>{{ c.name }}</span>
                  <i class="fas fa-chevron-right toggle-icon" v-if="!c.open"></i>
                  <i class="fas fa-chevron-down toggle-icon" v-if="c.open"></i>
                </div>
               

                <div v-if="c.open" style="margin-top:4px">
                  <div v-for="(s,index1) in c.topic" class="topic-row" :key="'ex-t-'+index1" @click="loadProject(s)">
                    <div class="topic-name">{{index1+1}}. {{ s.name }}</div>
                    <div class="topic-icon">
                      <i class="fas fa-code"></i>
                    </div>
                  </div>
                </div>
              </div>

              <div v-for="(c,index) in classes" v-if="tab == 'basic'" :key="'bs-'+index">
                <div @click.stop="openClass(c)"  class="class-row">
                  <div class="class-icon">
                    <i class="fas fa-folder"></i>
                  </div>
                  <span>{{ c.name }}</span>
                  <i class="fas fa-chevron-right toggle-icon" v-if="!c.open"></i>
                  <i class="fas fa-chevron-down toggle-icon" v-if="c.open"></i>
                </div>
               

                <div v-if="c.open" style="margin-top:4px">
                  <div v-for="(s,index1) in c.topic" class="topic-row" :key="'bs-t-'+index1" @click="loadProject(s)">
                    <div class="topic-name">{{index1+1}}. {{ s.name }}</div>
                  </div>
                </div>
              </div>

              <div v-for="(c,index) in advancedClasses"  v-if="tab == 'advanced'" :key="'ad-'+index">
                <div @click.stop="openClass(c)"  class="class-row">
                  <div class="class-icon">
                    <i class="fas fa-folder"></i>
                  </div>
                  <span>{{ c.name }}</span>
                  <i class="fas fa-chevron-right toggle-icon" v-if="!c.open"></i>
                  <i class="fas fa-chevron-down toggle-icon" v-if="c.open"></i>
                </div>
               

                <div v-if="c.open" style="margin-top:4px">
                  <div v-for="(s,index1) in c.topic" class="topic-row" :key="'ad-t-'+index1" @click="loadProject(s)">
                    <div class="topic-name">{{index1+1}}. {{ s.name }}</div>
                    <div class="topic-icon">
                      <i class="fas fa-code"></i>
                    </div>
                  </div>
                </div>
              </div>
          </div>
        </div>

        
      </div>
      <div class="coder">
        <div class="coder-wrapper">
        <editor v-model="code" lang="java" theme="monokai"  class="editor editor-font-2" ref="aceEditor" id="codeEditor" 
        :options="editorOptions" 
        ></editor>

        <div v-if="connected" class="connection-status connected">
          <span class="status-dot"></span>
          <span>Connected</span>
        </div>
        <div v-if="!connected" class="connection-status disconnected">
          <span class="status-dot"></span>
          <span>Disconnected</span>
        </div>

        <!-- 暂时注释掉 stdin 输入框
        <div class="stdin-input">
          <i class="fas fa-terminal"></i>
          <input v-model="stdin" placeholder="stdin input"/>
        </div>
        -->

       
        <div v-if="result!=null" class="result-panel">
          <div class="result-header">
            <span>Output</span>
            <button class="close-btn" @click="result = null">
              <i class="fas fa-times"></i>
            </button>
          </div>
          <div class="result-content" v-html="result"></div>
        </div>

        <!-- 暂时注释掉 Run Program 按钮
        <div class="buttons">
          <button @click="copyToClipboard" class="btn-run" :disabled="running">
            <i class="fas fa-play"></i>
            {{ running? 'Running...':'Run Program'}}
          </button>
        </div>
        -->
      </div>
      </div>
    </div>

    
  </div>
</template>

<script>
import editor from 'vue2-ace-editor'
import bus from '../utils/bus';
import util from '../utils/util';
require('brace/mode/java');
require('brace/theme/chrome');



export default {
  data() {
    return {
      code: "",
      classes:[],
      advancedClasses:[],
      exercises:[],
      font:2,
      connected:false,
      tab:"basic",
      result :null,
      stdin:"",
      running:false,
      editorOptions: {
        enableBasicAutocompletion: false,
        enableLiveAutocompletion: false,
        enableSnippets: false,
        enableLinking: false,
        foldStyle: 'manual',
      },
      socket:null,
      userInfo:null
    };
  },
  components:{
    editor
  },
  mounted() {
    var user = localStorage.getItem('user');
        if(user && user != null && user != ''){
            var userObj = JSON.parse(user);
            this.userInfo = userObj;
            console.log(userObj);
        }
        else{
            location.href = '/';
            return;
        }

      this.loadList();
      setTimeout( ()=>{
        document.getElementsByClassName("ace_text-input")[0].addEventListener('paste', this.handlePaste);
      },500);
      this.connectLoop();
  },
  methods: {
    switchTab(tab){
      this.tab = tab;
    },
    runJava(){
      this.running = true;
      this.result = "";
      const formData = new FormData();

      formData.append('file', this.code);
      formData.append('name','JavaBasic.java');
      formData.append('runtime',17);
  

      this.$http.post('https://api.anycodes.cn/v1/complier',formData,{
      headers: {
        'Content-Type': 'multipart/form-data',
      }}
      
      ).then(res=>{
        console.log(res.data.body.connect_id);

        const socket = new WebSocket('wss://api.anycodes.cn/terminal/'+res.data.body.connect_id);

        socket.addEventListener('message', event => {
          var obj = JSON.parse(event.data).message;
          if(obj.indexOf("\u001b") < 0){
            this.result += obj.replace(/\n/g, '<br>');
          }
          this.running = false;
        });
      })
    },
    copyToClipboard2(){
      var textarea = document.createElement('textarea');
          textarea.style.position = 'fixed';
          textarea.style.opacity = 0;
          textarea.value = this.code;
          document.body.appendChild(textarea);
          textarea.select();
          document.execCommand('copy');
          document.body.removeChild(textarea);
    },
    copyToClipboard() {
          if(this.code == ''){
            return;
          }

          if(this.running ){
            return;
          }

          this.running = true;
          this.result = null;

          var postInfo = {};
          postInfo.code = encodeURIComponent(this.code);
          postInfo.language = 7;
          postInfo.stdin = this.stdin;
          postInfo.fileext = "java";

          this.$http.post("https://aiapi.dctechonline.cn/api/runcode",postInfo).then(response => {
            console.log(response.data);
            this.running = false;
            this.result = response.data.output != '' ? response.data.output.replace(/\n/g, '<br>') : response.data.errors.replace(/\n/g, '<br>')
          });
      },
    connectLoop(){
      var mobile = this.userInfo.Mobile;
      var target = 'patrick';

      if(util.getSearchString('mobile') != null){
        mobile = util.getSearchString('mobile');
      }
      if(util.getSearchString('target')!= null){
        target = util.getSearchString('target');
      }

      if(mobile != null && mobile != ""){
        if(!this.connected){
          this.connectServer();
        }

        var interval = setInterval( ()=>{
          if(!this.connected){
            this.connectServer();
          }
          else{
            clearInterval(interval);
          }
        },5000);
        
      }
      else{
        mobile = 's1';
        target = 't1';
        if(!this.connected){
          this.connectServer();
        }

        var interval = setInterval( ()=>{
          if(!this.connected){
            this.connectServer();
          }
          else{
            clearInterval(interval);
          }
        },5000);
      }
    },
    handlePaste(){
      if(this.socket != null){
        var mobile = this.userInfo.Mobile;
      var target = 'patrick';

      if(util.getSearchString('mobile') != null){
        mobile = util.getSearchString('mobile');
      }
      if(util.getSearchString('target')!= null){
        target = util.getSearchString('target');
      }
        if(mobile == null || mobile == ""){
          mobile = 's1';
          target = 't1';
          
        }

        if(mobile == null || mobile == ""){
            return;
        }
        var sendStr = JSON.stringify({ type: 'classcode', value: this.code, target:target, from:mobile});
          try{
            this.socket.send(sendStr);
          }
          catch( err){
  
          }
      }
    },
    saveToFile() {
    const content = this.code;

    const blob = new Blob([content], { type: 'text/plain' });

    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = 'code.cpp';

   
    document.body.appendChild(a);

    a.click();

    window.URL.revokeObjectURL(url);

    document.body.removeChild(a);
  },
    connectServer(){
      
      var mobile = this.userInfo.Mobile;
      var target = 'patrick';

      if(util.getSearchString('mobile') != null){
        mobile = util.getSearchString('mobile');
      }
      if(util.getSearchString('target')!= null){
        target = util.getSearchString('target');
      }

      if(mobile == null || mobile == ""){
        mobile = 's1';
        target = 't1';
        
      }
      
      const socket = new WebSocket('wss://wss.dctechonline.cn:8024');
      this.socket = socket;

      socket.addEventListener('open', event1 => {
        console.log('WebSocket connection established.');
        
        socket.send(JSON.stringify(
          {
              type:"user",
              mobile:mobile,
              target:target,
              classType:'cpp',
          }));


          var interval2 = setInterval( ()=>{
            if(this.loopCheck == false){
              
              clearInterval(interval2);
              this.connected = false;
              this.connectLoop();
              return;
            }
            else{
              socket.send(JSON.stringify(
              {
                  type:"loopcheck",
                  mobile:mobile
              }))
              this.loopCheck = false;
              console.log('check successful');
            }
          },20000);


          this.connected = true;

          socket.addEventListener('message', event => {
        const reader = new FileReader();
  
          reader.addEventListener('loadend', () => {
            const text = reader.result;
            const data = JSON.parse(text);
            const { type, value,from } = data;
            console.log(data);
            if (type === 'classcode' && from == target) {
              this.code = value;
            }
            else if(type ==="loopcheck"){
              this.loopCheck = true;
            }
          });
  
          reader.readAsText(event.data);
        });
  
        if(this.$refs.aceEditor){
          this.$refs.aceEditor.$vnode.elm.children[0].addEventListener('input', event => {
            var sendStr = JSON.stringify({ type: 'classcode', value: this.code, target:target, from:mobile});
            try{
              socket.send(sendStr);
            }
            catch( err){
            }
          
          });
        }
      });

    },
    openClass(c){
      if(c.open){
        c.open = false;
      }
      else{
        c.open = true;
      }
    },
    changeFont(f){
      this.font = f;
      if(f == 1){
        $("#codeEditor").removeClass("editor-font-1");
        $("#codeEditor").removeClass("editor-font-2");
        $("#codeEditor").removeClass("editor-font-3");
        $("#codeEditor").addClass("editor-font-1");
      }
      else if(f == 2){
      
        $("#codeEditor").removeClass("editor-font-1");
        $("#codeEditor").removeClass("editor-font-2");
        $("#codeEditor").removeClass("editor-font-3");
        $("#codeEditor").addClass("editor-font-2");
      
      }
      else if(f == 3){
        $("#codeEditor").removeClass("editor-font-1");
        $("#codeEditor").removeClass("editor-font-2");
        $("#codeEditor").removeClass("editor-font-3");
        $("#codeEditor").addClass("editor-font-3");
      }
    },
    loadList(){
     
      var r = new Date().getTime();
      var index = util.getSearchString("id");
      this.$http.get("/data/classes/ap"+index+".json?random="+r).then(response => {
        this.classes = response.data;
      });

    },
    loadProject(p){
         var r = new Date().getTime();
        this.$http.get(p.path+"?random="+r, { responseType: 'arraybuffer' }).then(response => {
          const decoder = new TextDecoder('utf-8');
          const content = decoder.decode(response.data);
          this.code = content;
        }).catch(error => {
         
        });
    },
  },
};
</script>

<style lang="scss">
@import '@/styles/variables.scss';

.cpp-content{
  position: fixed;
  top:76px !important;
  left:0px;
  width:100%;
  height:calc(100% - 76px) !important;
  display: flex;
  background: $bg-primary;

  .coder{
    flex: 1;
    height:100%;
    overflow: hidden;
    position: relative;
    padding: 12px;
    
    .coder-wrapper {
      height: 100%;
      background: white;
      border-radius: 12px;
      box-shadow: $shadow-card;
      border: 1px solid $border-light;
      overflow: visible;
      position: relative;
    }

    .editor{
      width:100%;
      height: 100%;
      border-radius: 12px;

      .ace_print-margin{
        display: none;
      }

      &.editor-font-1{
        font-size: 12px !important;
      }

      &.editor-font-2{
        font-size: 14px !important;
      }

      &.editor-font-3{
        font-size: 16px !important;
      }
    }
    
    .connection-status {
      position: absolute;
      top: 6px !important;
      right: 6px;
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 8px 14px;
      border-radius: 20px;
      font-size: 12px;
      font-weight: 500;
      
      .status-dot {
        width: 8px;
        height: 8px;
        border-radius: 50%;
      }
      
      &.connected {
        background: rgba($success-color, 0.1);
        color: $success-color;
        
        .status-dot {
          background: $success-color;
          box-shadow: 0 0 8px rgba($success-color, 0.5);
        }
      }
      
      &.disconnected {
        background: rgba($danger-color, 0.1);
        color: $danger-color;
        
        .status-dot {
          background: $danger-color;
        }
      }
    }
    
    .stdin-input {
      position: absolute;
      bottom: 12px;
      right: 200px;
      display: flex;
      align-items: center;
      gap: 8px;
      background: white;
      border: 1px solid $border-color;
      border-radius: 8px;
      padding: 0 12px;
      height: 36px;
      
      i {
        color: $text-muted;
        font-size: 11px;
      }
      
      input {
        border: none;
        outline: none;
        font-size: 12px;
        padding: 0;
        width: 140px;
        height: 100%;
        
        &::placeholder {
          color: $text-muted;
        }
      }
    }
    
    .result-panel {
      position: absolute;
      left: 12px;
      right: 12px;
      bottom: 56px;
      background: $bg-dark;
      border-radius: 10px;
      max-height: 180px;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      
      .result-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 12px 16px;
        background: rgba(255, 255, 255, 0.05);
        color: white;
        font-size: 13px;
        font-weight: 500;
        
        .close-btn {
          background: none;
          border: none;
          color: rgba(255, 255, 255, 0.6);
          cursor: pointer;
          padding: 4px;
          transition: color 0.2s;
          
          &:hover {
            color: white;
          }
        }
      }
      
      .result-content {
        padding: 16px;
        color: rgba(255, 255, 255, 0.9);
        font-family: $font-mono;
        font-size: 13px;
        line-height: 1.6;
        overflow: auto;
        max-height: 150px;
      }
    }
    
    .buttons{
      position: absolute;
      bottom: 12px;
      right: 12px;
      z-index: 10;
    }

    .btn-run {
      background: $primary-gradient;
      color: white;
      border: none;
      padding: 14px 28px;
      border-radius: 12px;
      font-size: 15px;
      font-weight: 600;
      cursor: pointer;
      transition: all 0.3s ease;
      display: flex;
      align-items: center;
      gap: 10px;
      box-shadow: $shadow-primary;
      
      i {
        font-size: 13px;
      }
      
      &:hover:not(:disabled) {
        transform: translateY(-2px);
        box-shadow: 0 14px 44px -10px rgba($primary-color, 0.5);
      }
      
      &:disabled {
        opacity: 0.7;
        cursor: not-allowed;
      }
    }
  }
  
  .panel{
    width: 340px;
    border-left:none !important;
    
    .result{
      width:100%;
      height:50%;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      border-bottom:1px solid #eee;

      .title{
        position: absolute;
        top:0px;
        left:0px;
        width:100%;
        padding:10px;
        font-weight:bold;
        font-size:14px;
      }
      canvas{
        max-width:100%;
        max-height:100%;
      }
    }

    .notes{
      margin:12px;
      height:calc(100% - 24px);
      background: white;
      padding: 14px;
      border-radius: 12px;
      box-shadow: $shadow-card;
      border: 1px solid $border-light;
      overflow: auto;
      
      @include scrollbar-custom;

      .tabs{
        display: flex;
        
        font-size:14px;
        justify-content: space-around;
        .tab{
          width:50%;
          text-align: center;
          padding:10px 0px;
          cursor: pointer;
          border-bottom: 1px solid #eee;;
          
          &.active{
            background: #8fbc8f !important;
            
            color:white;
          }
        }
      }
    }
  }
}

.ace_gutter-cell.error-line{
  background:orangered;
  color:white;
}


.ace_gutter-cell .ace_fold-widget{
  display: none !important
}

.pjsconsole{
  width:60%;
  height:150px !important;
  .console{
    overflow-y: auto !important;
    height:150px !important;
    padding-bottom:20px;
  }
}

.project-row{
  display:flex;
  justify-content: space-between;
  padding:5px 10px;
  font-size:15px;
  cursor: pointer;

  &:hover{
    background:#eee;
  }
}

.class-row{
  padding: 8px 10px;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  transition: all 0.2s ease;
  margin-bottom: 3px;
  
  .class-icon {
    width: 24px;
    height: 24px;
    background: rgba($primary-color, 0.1);
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: $primary-color;
    font-size: 11px;
  }
  
  .toggle-icon {
    margin-left: auto;
    font-size: 11px;
    color: $text-muted;
    transition: all 0.2s ease;
  }

  &:hover{
    background: rgba($primary-light, 0.3);
    
    .class-icon {
      background: $primary-light;
      color: white;
    }
    
    .toggle-icon {
      color: $primary-light;
    }
    
    span {
      color: $primary-dark;
      font-weight: 600;
    }
  }
}

.topic-row{
  cursor: pointer;
  font-size: 13px;
  padding: 7px 10px 7px 36px;
  display: flex;
  color: $text-secondary;
  justify-content: space-between;
  align-items: center;
  border-radius: 6px;
  transition: all 0.2s ease;
  margin-bottom: 2px;
  
  .topic-name {
    flex: 1;
  }
  
  .topic-icon {
    width: 24px;
    height: 24px;
    background: rgba($secondary-color, 0.1);
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: $secondary-color;
    font-size: 10px;
    opacity: 0;
    transition: opacity 0.2s;
  }

  &:hover{
    background: $bg-secondary;
    color: $text-primary;
    
    .topic-icon {
      opacity: 1;
    }
  }
}

.error-layer{
  position: fixed;
  bottom:0px;
  height:180px;
  left:0px;
  width:60%;
  background:#eee;
  border-top:1px solid #ccc;
}
.ace_identifier{
  color:rgb(189, 60, 1);

}

.ace_numeric{
  color:#038795 !important;
}

.ace_keyword{
  color:rgb(43, 90, 1) !important;

}
</style>
